import { OverlayTrigger, Popover } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { getThumbnailImage } from '../../../utils/textHelper';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';
import { NAVIGATION_PANEL_DISPLAY_TYPE } from '../../../constants/analytics';

import styles from './ThumbnailImageWithHover.module.scss';

export function ThumbnailImageWithHover({ src, alt }) {
  const { displayType } = useSelector((state) => state.pageLayout.navigationPanel);
  const thumbnailSrc = src ? getThumbnailImage(src) : null;
  const size = displayType === NAVIGATION_PANEL_DISPLAY_TYPE.FULL ? 160 : 120;

  const overlay = (
    <Popover placement="left" className={styles.popupWrapper}>
      <Popover.Body className={styles.popupBody}>
        <img src={thumbnailSrc} alt={alt} width={size} height={size} />
      </Popover.Body>
    </Popover>
  );

  return (
    <div className="thumbnail-image-with-hover">
      {src ? (
        <OverlayTrigger placement="left" trigger={['hover', 'focus']} overlay={overlay}>
          <img src={thumbnailSrc} alt={alt} />
        </OverlayTrigger>
      ) : (
        NO_VALUE_PLACEHOLDER
      )}
    </div>
  );
}

ThumbnailImageWithHover.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
};
